import {useSelector} from "react-redux";
import Restricted from "@/components/permissions/Restricted.tsx";
import {useState} from "react";
import Form from "@/components/form/Form.tsx";
import FieldObject from "@/components/form/FieldObject.tsx";
import {EmailValidator, useForm} from "@/components/form/Helpers.ts";
import TextField from "@/components/editor/fields/TextField.tsx";
import {Button} from "@/components/ui/button.tsx";
import {keycloakApi} from "@/main.tsx";
import {Badge} from "@/components/ui/badge.tsx";


export default function Account() {

    const user = useSelector((state: any) => state.auth.user);
    const [editing, setEditing] = useState(false)
    const [userForm, setUserForm] = useForm()

    console.log(user)

    async function submit() {
        const data = userForm.fieldValues
        delete data["token"]
        await keycloakApi.post("/account", data)
        window.location.reload()
    }

    return <div className={"container mx-auto mb-10 px-4"}>
        <div className={'flex gap-3'}>
            <Form formValue={userForm} onChange={setUserForm} initialValues={user}
                  onSubmit={submit}>
                <div className={"w-36 h-36 bg-sidebar rounded-md"}></div>
                <div className={"flex justify-between w-full pr-4"}>
                    <div className={'flex flex-col justify-between'}>
                        {editing ? <>

                            <div className={"flex gap-4"}>
                                <TextField name={"firstName"} label={"Keresztnév"} placeholder={"Keresztnév"}/>
                                <TextField name={"lastName"} label={"Vezetéknév"} placeholder={"Vezetéknév"}/>
                            </div>
                            <TextField name={"email"} label={"Email"} placeholder={"Email"} validate={EmailValidator}/>
                            <FieldObject name={"attributes"}>
                                <TextField name={"phone"} label={"Telefonszám"}/>
                            </FieldObject>

                        </> : <>
                            <p className={'font-bold text-2xl'}>{user?.firstName + " " + user?.lastName}</p>
                            <p className={'font-bold text-lg'}>{user?.attributes?.title}</p>
                            <p className={''}>{user?.email} {user?.attributes?.phone}</p></>}
                    </div>
                    <Button onClick={() => {
                        if(!editing) {
                            setEditing(true)
                        } else {
                            setEditing(false)
                            submit()
                        }
                    }}>
                        {!editing ? "Szerkesztés" : "Mentés"}
                    </Button>
                </div>
            </Form>
        </div>

        <div className={'gap-3 my-4'}>
            <p className={'font-bold text-lg'}>Jogosultságok</p>
            <div className={'flex flex-wrap gap-4'}>
                <Restricted to={"user.any"}>
                    <Badge variant={"secondary"} className={"px-4"}>Felhasználók kezelése</Badge>
                </Restricted>
                <Restricted to={"torzsgarda"}>
                    <Badge variant={"secondary"} className={"px-4"}>Törzsgárda használata</Badge>
                </Restricted>

            </div>
        </div>
    </div>
}